// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Units = require("../../../uikit/reason/helpers/Units.bs.js");

let toString = Units.hex_to_string;

let white = {
  NAME: "hex",
  VAL: "ffffff"
};

let jumbo = {
  NAME: "hex",
  VAL: "71717a"
};

let crimson = {
  NAME: "hex",
  VAL: "dc1a43"
};

let facebook = {
  NAME: "hex",
  VAL: "3b5998"
};

let twitter = {
  NAME: "hex",
  VAL: "1da1f2"
};

let instagram = {
  NAME: "hex",
  VAL: "e1306c"
};

let yelp = {
  NAME: "hex",
  VAL: "af0606"
};

let linkedin = {
  NAME: "hex",
  VAL: "0077b5"
};

let youtube = {
  NAME: "hex",
  VAL: "cd201f"
};

let pinterest = {
  NAME: "hex",
  VAL: "bd081c"
};

exports.toString = toString;
exports.white = white;
exports.jumbo = jumbo;
exports.crimson = crimson;
exports.facebook = facebook;
exports.twitter = twitter;
exports.instagram = instagram;
exports.yelp = yelp;
exports.linkedin = linkedin;
exports.youtube = youtube;
exports.pinterest = pinterest;
/* No side effect */
